import { useMemo } from 'react';

import { useCacheQuery } from '../../../hooks/use-cache-query';
import {
  GetHealthProviderItemsDocument,
  HealthProviderItemDataFragment,
} from '../../types/api/graphql';

export function useHealthProviderItems() {
  const { data: healthProviderItemsData, loading: healthProviderItemsLoading } =
    useCacheQuery(GetHealthProviderItemsDocument);

  const data = useMemo(
    () =>
      (healthProviderItemsData?.healthProviders ?? []).map(
        option => option as HealthProviderItemDataFragment
      ),
    [healthProviderItemsData?.healthProviders]
  );

  return {
    data,
    loading: healthProviderItemsLoading,
  };
}
